module.exports = "/images/aerial-2.jpg";